// 即時推播（SSE）：舊版 App.jsx 掛載時 listener.listen() 一次，收到事件就重抓對應資料。
// @/lib/listener 是從舊版原樣複製的（reload／kickout 事件會整頁重載）。
// 新增要隨推播更新的資料時：在這裡 events.on(事件, () => queryClient.invalidateQueries({ queryKey }))。
import { useEffect } from 'react'
import { useQueryClient } from '@tanstack/react-query'
import listener, { events, MERCHANT_PRICING_ADDED, MERCHANT_PRICING_REVIEWED } from '@/lib/listener'
import { PRICING_PENDING_KEY } from './useMenuBadges'

// EventSource 整個 App 只開一條；StrictMode 開發模式會跑兩次 effect，用模組層變數擋住第二條連線。
// 開發時 HMR 重跑本模組會把變數清回 null，先關掉舊連線，否則新舊兩條並存、每個推播收兩次
let source = null
if (import.meta.hot) {
  import.meta.hot.dispose(() => {
    source?.close()
    source = null
  })
}

export function useRealtime() {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (source) return
    source = listener.listen()
  }, [])

  useEffect(() => {
    const refreshPricing = () => queryClient.invalidateQueries({ queryKey: PRICING_PENDING_KEY })
    events.on(MERCHANT_PRICING_ADDED, refreshPricing)
    events.on(MERCHANT_PRICING_REVIEWED, refreshPricing)
    return () => {
      events.off(MERCHANT_PRICING_ADDED, refreshPricing)
      events.off(MERCHANT_PRICING_REVIEWED, refreshPricing)
    }
  }, [queryClient])
}
